import { TCompanyMenu } from "@/features/company/types/companyMenu";
import { AppRoutes } from "@/routes/config";

export const companyMenu: TCompanyMenu[] = [
  {
    title: "契約中の企業一覧",
    url: AppRoutes.duringContractCompanyList,
    extraUrls: [AppRoutes.duringContractCompanyList],
  },
  {
    title: "解約済みの企業一覧",
    url: AppRoutes.cancelledContractCompanyList,
    extraUrls: [AppRoutes.cancelledContractCompanyList],
  },
  {
    title: "トライアル中の企業一覧",
    url: AppRoutes.trialCompanyList,
    extraUrls: [AppRoutes.trialCompanyList],
  },
  {
    title: "トライアル終了の企業一覧",
    url: AppRoutes.trialCancelledCompanyList,
    extraUrls: [AppRoutes.trialCancelledCompanyList],
  },
];
